<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1>ساخت زبان جدید</h1>
          <b-form class="p-2" @submit.prevent>
            <b-row>
              <b-col cols="12" md="6">
                <!-- Language Eng Title -->
                <b-form-group label="نام انگلیسی زبان" label-for="lang-eng">
                  <b-form-input
                    id="lang-eng"
                    v-model="languageDetails.title"
                    trim
                    placeholder="English"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <!-- Language Persian Title -->
                <b-form-group label="نام فارسی زبان" label-for="persian-title">
                  <b-form-input
                    id="persian-title"
                    v-model="languageDetails.persianTitle"
                    trim
                    placeholder="انگلیسی"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  class="mb-0"
                  label="توضیحات زبان"
                  label-for="description"
                >
                  <quillEditor
                    id="description"
                    class="mt-1"
                    v-model="languageDetails.description"
                    :options="editorOption"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" class="my-1">
                <b-form @submit.prevent>
                  <b-form-group label="کاور زبان" label-for="imageFile">
                    <b-form-file
                      id="imageFile"
                      v-model="imageFile"
                      accept="image/*"
                      @input="handleImageFile"
                    ></b-form-file>
                  </b-form-group>
                </b-form>
              </b-col>
              <b-col cols="12" md="6" class="my-1">
                <div v-if="imageFile">
                  <p>پیشنمایش تصویر زبان</p>
                  <div class="position-relative">
                    <img
                      style="
                        width: 100%;
                        max-height: 20rem;
                        object-fit: contain;
                      "
                      :src="imagePreview"
                      alt=""
                    />
                    <feather-icon
                      icon="Trash2Icon"
                      size="25"
                      class="text-danger position-absolute"
                      style="left: 1rem; top: 1rem; cursor: pointer"
                      @click="deletePreviewImage"
                    />
                  </div>
                </div>
              </b-col>
              <b-col cols="12" class="mt-2">
                <div class="d-flex align-items-center justify-content-end">
                  <b-button variant="primary" @click="createNewLanguage">
                    ثبت
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BOverlay,
  BFormFile,
} from "bootstrap-vue";
import { CreateLanguage } from "../../../libs/Api/Language";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { quillEditor } from "vue-quill-editor";

export default {
  data() {
    return {
      isLoading: false,
      languageDetails: {
        title: null,
        persianTitle: null,
        description: null,
        MainPic: null,
      },
      imageFile: null,
      imagePreview: null,
      editorOption: {
        // Some Quill options...
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      },
    };
  },
  methods: {
    deletePreviewImage() {
      URL.revokeObjectURL(this.imageFile);
      this.imagePreview = null;
      this.imageFile = null;
    },
    handleImageFile() {
      if (this.imageFile) {
        this.imagePreview = URL.createObjectURL(this.imageFile);
      }
    },
    createNewLanguagePayloadAsFormData() {
      let myFormData = new FormData();
      Object.keys(this.languageDetails).forEach((key) => {
        if (this.languageDetails[key] != null) {
          myFormData.append(key, this.languageDetails[key]);
        }
      });
      if (this.imageFile) {
        myFormData.append("MainPic", this.imageFile);
      }
      return myFormData;
    },
    async createNewLanguage() {
      try {
        this.isLoading = true;
        let _this = this;
        let createLanguage = new CreateLanguage(_this);
        createLanguage.setFormData(_this.createNewLanguagePayloadAsFormData());
        await createLanguage.sendFormData(
          function (response) {
            if (response.data.isSuccess) {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "زبان با موفقیت ساخته شد",
                  icon: "FlagIcon",
                  variant: "success",
                },
              });
              _this.languageDetails = {
                title: null,
                persianTitle: null,
                description: null,
                MainPic: null,
              };
              _this.deletePreviewImage();
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BFormGroup,
    BButton,
    BOverlay,
    BFormFile,
    quillEditor,
  },
};
</script>
